__turbopack_context__.v({
  "card": "Card-module-scss-module__UR5N_W__card",
  "exampleContent": "Card-module-scss-module__UR5N_W__exampleContent",
  "exampleTitle": "Card-module-scss-module__UR5N_W__exampleTitle",
  "icon": "Card-module-scss-module__UR5N_W__icon",
  "loading": "Card-module-scss-module__UR5N_W__loading",
  "mobileMethodCardOverlay": "Card-module-scss-module__UR5N_W__mobileMethodCardOverlay",
  "noInstallation": "Card-module-scss-module__UR5N_W__noInstallation",
  "noResults": "Card-module-scss-module__UR5N_W__noResults",
  "parameter": "Card-module-scss-module__UR5N_W__parameter",
  "parametersContent": "Card-module-scss-module__UR5N_W__parametersContent",
  "parametersTitle": "Card-module-scss-module__UR5N_W__parametersTitle",
  "returnsContent": "Card-module-scss-module__UR5N_W__returnsContent",
  "returnsTitle": "Card-module-scss-module__UR5N_W__returnsTitle",
  "space": "Card-module-scss-module__UR5N_W__space",
  "valueName": "Card-module-scss-module__UR5N_W__valueName",
  "valueType": "Card-module-scss-module__UR5N_W__valueType",
});
